var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 20C15.7728 20 20.25 15.5228 20.25 10C20.25 4.47715 15.7728 0 10.25 0C4.72715 0 0.25 4.47715 0.25 10C0.25 15.5228 4.72715 20 10.25 20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36184 13.3333C9.24495 13.334 9.12908 13.31 9.02087 13.2627C8.91266 13.2153 8.81423 13.1455 8.73124 13.0573L6.06676 10.2018C5.98395 10.1131 5.91826 10.0077 5.87344 9.89177C5.82862 9.77581 5.80556 9.65153 5.80556 9.52603C5.80556 9.27256 5.89951 9.02947 6.06676 8.85023C6.234 8.671 6.46083 8.57031 6.69735 8.57031C6.93387 8.57031 7.1607 8.671 7.32795 8.85023L9.36184 11.0394L13.1721 6.94659C13.3393 6.76736 13.5661 6.66667 13.8026 6.66667C14.0392 6.66667 14.266 6.76736 14.4332 6.94659C14.6005 7.12582 14.6944 7.36891 14.6944 7.62238C14.6944 7.87585 14.6005 8.11895 14.4332 8.29818L9.99243 13.0573C9.90944 13.1455 9.81102 13.2153 9.70281 13.2627C9.5946 13.31 9.47873 13.334 9.36184 13.3333Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.492b61798fe010daa8c70d4a33850afe.svg";
export { ForwardRef as ReactComponent };